// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"73b78e22","453":"9c143f9f","732":"f8f39e4e"}[chunkId] + ".chunk.js";
};